/*
    创建axios 实例
*/

import Axios from 'axios';
import { ElLoading, ElMessage } from 'element-plus';

const axios = Axios.create();

// 防止点击遮罩
const loadingManage = {};
let _uid = 0;

axios.interceptors.response.use((response) => {
  const loadingUid = response.config.loadingUid;
  const { config, data } = response;
  if (loadingUid) {
    // 关闭请求前 设置的遮罩
    loadingManage[loadingUid] && loadingManage[loadingUid].close();
  }
  if (config.__warn && (data?.message || data?.msg) && data && !data.success) {
    // 如果参数包含__warn: true
    // 给出报错提示
    ElMessage({
      showClose: true,
      message: data.message || data.msg,
      type: 'error'
    });
  }
  return response;
});

axios.interceptors.request.use((request) => {
  if (request.data?.__repeat || request.params?.__repeat) {
    // 如果参数中包含 __repeat: true 请求前添加遮罩 防止用户多次触发
    const loadInstance = ElLoading.service({
      fullscreen: true,
      lock: true,
      text: 'Loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    const loadingUid = ++_uid;
    request.loadingUid = loadingUid;
    loadingManage[loadingUid] = loadInstance;
  }
  if (request.data?.__warn || request.params?.__warn) {
    request.__warn = true;
  }
  return request;
});

export default axios;
